// extracted by mini-css-extract-plugin
module.exports = {"sm":"Modal_sm__2uw8J","md":"Modal_md__yJU0j","lg":"Modal_lg__3rMS2","xl":"Modal_xl__r7aUw","xl2":"Modal_xl2__31MBZ"};